<template>
  <div class="operate">
    <div class="devices">
      <div v-for="(item, index) in deviceTypes" :key="index"
        @click="handleClick(item, index)" class="device">
        <div :class="[{ active: item.isActive }, 'device__icon']">
          <img :src="item.icon" class="device__icon--img"/>
        </div>
        <div class="device__type">
          {{item.label}}
        </div>
      </div>
      <div class="status-bar">
        {{saveWords}}
      </div>
    </div>
    <div class="cancel" @click="handleReset()">
      <i class="el-icon-circle-close"></i>
    </div>
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep';
import { deviceTypes as deviceTypesConfig } from '@/config/deviceTypes.js';
import eventHub from '@/utils/eventHub';
import { events } from '@/utils/events'
const deviceTypes = clonedeep(deviceTypesConfig);

export default {
  data() {
    return {
      deviceTypes,
      saveWords: '',
    }
  },
  created() {
    eventHub.$on(events.AUTO_SAVE_WORDS, this.eventAutoSaveWords)
    eventHub.$on(events.CANCEL_DEVICE_TYPE_CHECKED, this.eventCancelDeviceTypeChecked)
  },
  methods: {
    eventAutoSaveWords(words) {
      this.saveWords = words;
    },
    eventCancelDeviceTypeChecked(index) {
      this.setChecked(index);
    },
    setChecked(index = -1) {
      const { deviceTypes } = this;
      deviceTypes.forEach((device, i) => {
        if (i === index) {
          this.$set(device, 'isActive', true);
        } else {
          this.$set(device, 'isActive', false);
        }
      })
    },
    handleClick(device, index) {
      this.setChecked(index);
      eventHub.$emit(events.DEVICE_TYPE_CHECKED, device);
    },
    handleReset() {
      this.setChecked();
    },
  },
  beforeDestroy() {
    eventHub.$off(events.AUTO_SAVE_WORDS, this.eventAutoSaveWords)
    eventHub.$off(events.CANCEL_DEVICE_TYPE_CHECKED, this.eventCancelDeviceTypeChecked)
  }
}
</script>

<style lang="less" scoped>
@deepBlack: #18191A;
@shadowBlack: #2C2C2E;
.operate {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  .devices {
    display: flex;
    font-size: 14px;
    align-items: flex-end;
    .device {
      width: 80px;
      // text-align: center;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      &__icon {
        width: 30px;
        height: 30px;
        margin: 0 auto 5px;
        padding: 14px;
        position: relative;
        &--img {
          width: 80%;
          height: 80%;
          position: absolute;
          left: 10%;
          top: 10%;
          z-index: 2;
        }
      }
      .active {
        box-sizing: border-box;
        border: 2px solid rosybrown;
        &:before {
          content: '';
          position: absolute;
          display: block;
          width: 120%;
          height: 50%;
          z-index: 1;
          left: -10%;
          top: 0;
          background: @shadowBlack;
          transform: translateY(50%);
        }
        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 50%;
          height: 120%;
          z-index: 1;
          left: 0;
          top: -10%;
          background: @shadowBlack;
          transform: translateX(50%);
        }
      }
    }
    .status-bar {
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      padding-left: 10px;
      border-left: 1px solid #18191A;
      color: #aaaa;
      margin-left: 20px;
    }
  }
  .cancel {
    font-size: 30px;
    cursor: pointer;
  }
}

</style>